/* global require */
import Vue from "vue";
import { iconButton, iconButtonTitle } from "./image-viewer-icon-button";

export default Vue.component("fullscreen-toggle", {
  props: ["checked"],

  directives: {
    iconButton,
    title: iconButtonTitle
  },

  data() {
    return {
      icons: {
        enter: "image-viewer-fullscreen-enter",
        exit: "image-viewer-fullscreen-exit"
      },

      titles: {
        enter: "Enter Fullscreen",
        exit: "Exit Fullscreen"
      }
    };
  },

  computed: {
    icon() {
      return this.checked ? this.icons.exit : this.icons.enter;
    },

    title() {
      return this.checked ? this.titles.exit : this.titles.enter;
    }
  },

  template: require("./templates/image-viewer-fullscreen-toggle.html")
});



// WEBPACK FOOTER //
// ./src/frontend/common/image-viewer/image-viewer-fullscreen-toggle.js